import React from 'react';
import './ProductPopup.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPaperPlane,
  faHeart,
  faBookmark
} from '@fortawesome/free-solid-svg-icons';

const ProductPopup = ({
  product,
  onClose,
  onShare,
  onSave,
  isSaved,
  trackAttribution,
  fallbackImage
}) => {
  if (!product) return null;

  // Truncate description to fit elegantly (max 300 characters)
  const maxDescriptionLength = 300;
  const truncatedDescription = product.description && product.description.length > maxDescriptionLength
    ? product.description.substring(0, maxDescriptionLength) + '...'
    : product.description || 'A carefully curated product that embodies quality design and craftsmanship.';

  const handleBuyClick = () => {
    if (trackAttribution) {
      trackAttribution('product_clicked', product.id);
    }
    window.open(product.vendor_url || product.affiliateURL, '_blank');
  };

  const handleShare = async () => {
    const shareData = {
      title: product.title,
      text: `Check out ${product.title} on Artifex`,
      url: window.location.href
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
        if (onShare) onShare();
      } else {
        await navigator.clipboard.writeText(shareData.url);
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Share error:', error);
      }
    }
  };

  return (
    <div className="product-popup-overlay" onClick={onClose}>
      <div className="product-popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="product-popup-inner">

          {/* Header Section */}
          <div className="popup-header">
            <div className="popup-header-actions">
              <button
                className="popup-action-icon"
                onClick={handleShare}
                title="Share"
              >
                <FontAwesomeIcon icon={faPaperPlane} style={{ color: '#666' }} />
              </button>
              <button
                className="popup-action-icon"
                onClick={() => {}}
                title="Like"
              >
                <FontAwesomeIcon icon={faHeart} style={{ color: '#666' }} />
              </button>
              <button
                className="popup-action-icon"
                onClick={(e) => onSave && onSave(e, product)}
                title="Save"
                style={{
                  background: isSaved && isSaved(product.id) ? '#000080' : '#f5f5f5',
                  color: isSaved && isSaved(product.id) ? 'white' : '#666'
                }}
              >
                <FontAwesomeIcon icon={faBookmark} />
              </button>
            </div>

            <div className="popup-subtitle">
              {product.category || 'Product'}
            </div>

            <h1
              className="popup-title"
              onClick={handleBuyClick}
              style={{ cursor: 'pointer' }}
              onMouseEnter={(e) => e.target.style.color = '#0d47a1'}
              onMouseLeave={(e) => e.target.style.color = '#222'}
            >
              {product.title}
            </h1>
          </div>

          {/* Main Content Layout */}
          <div className="popup-content-grid">

            {/* Left Column: Image */}
            <div className="popup-image-section">
              <div
                className="popup-product-image"
                onClick={handleBuyClick}
              >
                <img
                  src={product.image_url || product.imageUrl}
                  alt={product.title}
                  onError={(e) => { e.target.src = fallbackImage }}
                />
              </div>

              <div className="popup-image-caption">
                {product.brand || product.vendor_name} • ${product.price}
              </div>

              {/* Buy Button directly below image */}
              <div className="popup-image-actions">
                <button
                  className="popup-btn-primary popup-btn-below-image"
                  onClick={handleBuyClick}
                >
                  Buy Now
                </button>
              </div>
            </div>

            {/* Right Column: Content */}
            <div className="popup-info-section">

              {/* Description */}
              <div className="popup-description">
                <p>{truncatedDescription}</p>

                {product.tags && product.tags.length > 0 && (
                  <p className="popup-features">
                    Features: {product.tags.slice(0, 3).join(', ').toLowerCase()}
                  </p>
                )}
              </div>

              {/* Additional Action Button */}
              <div className="popup-actions">
                <div className="popup-primary-actions">
                  <button
                    className="popup-btn-secondary"
                    onClick={handleBuyClick}
                  >
                    View Full Details
                  </button>
                </div>
              </div>

            </div>
          </div>

          {/* Bottom Details */}
          {product.category && (
            <div className="popup-details">
              <div className="popup-details-grid">
                <div className="popup-detail-item">
                  <div className="popup-detail-label">Category</div>
                  <div className="popup-detail-value">{product.category}</div>
                </div>

                {product.brand && (
                  <div className="popup-detail-item">
                    <div className="popup-detail-label">Brand</div>
                    <div className="popup-detail-value">{product.brand || product.vendor_name}</div>
                  </div>
                )}

                {product.asin && (
                  <div className="popup-detail-item">
                    <div className="popup-detail-label">Item ID</div>
                    <div className="popup-detail-value">{product.asin}</div>
                  </div>
                )}
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default ProductPopup;
